<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="id_tipo_persona" class="block text-sm font-medium text-gray-700">Tipo de Persona</label>
      <select id="id_tipo_persona" :value="(loadData.id_tipo_persona == 4) ? '4' : loadData.id_tipo_persona"
        :disabled="loadData.id_tipo_persona == 4"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        @change="(tipoPersonaNew) => $emit('updateValues', { 'id_tipo_persona': customUpdateValueData('id_tipo_persona', tipoPersonaNew.target.value) })">
        <option value="" selected> Seleccione tipo de Documento...</option>
        <option v-for="(tipoPersona, index) of collectionTipoPersona" :key="'B' + index" :value="tipoPersona.id">{{
          tipoPersona.nombre
        }}
        </option>
        <option value="4" v-if="loadData.id_tipo_persona == 4"> Externo</option>

      </select>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="primer_nombre" class="block text-sm font-medium text-gray-700">Nombre</label>
      <input type="text" id="primer_nombre" :value="loadData.primer_nombre"
        @change="(primer_nombreNew) => $emit('updateValues', { 'primer_nombre': primer_nombreNew.target.value })"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="segundo_nombre" class="block text-sm font-medium text-gray-700">Segundo Nombre</label>
      <input type="text" id="segundo_nombre" :value="loadData.segundo_nombre"
        @change="(segundo_nombreNew) => $emit('updateValues', { 'segundo_nombre': segundo_nombreNew.target.value })"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>

    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="primer_apellido" class="block text-sm font-medium text-gray-700">Primer Apellido</label>
      <input type="text" id="primer_apellido" :value="loadData.primer_apellido"
        @change="(primer_apellidoNew) => $emit('updateValues', { 'primer_apellido': primer_apellidoNew.target.value })"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>

    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="segundo_apellido" class="block text-sm font-medium text-gray-700">Segundo Apellido</label>
      <input type="text" id="segundo_apellido" :value="loadData.segundo_apellido"
        @change="(segundo_apellidoNew) => $emit('updateValues', { 'segundo_apellido': segundo_apellidoNew.target.value })"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>

    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="id_tipo_identificacion" class="block text-sm font-medium text-gray-700">Tipo de Documento</label>
      <select id="id_tipo_identificacion" :value="loadData.id_tipo_identificacion"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        @change="(tipoDocNew) => $emit('updateValues', { 'id_tipo_identificacion': customUpdateValueData('id_tipo_identificacion', tipoDocNew.target.value) })">
        <option value="" selected>Seleccione un tipo...</option>
          <option v-for="(tipoDoc, index) of collectionTipoDoc" :key="'B' + index" :value="tipoDoc.id">{{ tipoDoc.nombre_tipo_identificacion }}</option>
     
      </select>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="identificacion" class="block text-sm font-medium text-gray-700"># identificacion</label>
      <input type="text" id="identificacion" :value="loadData.identificacion"
        @change="(identificacionNew) => $emit('updateValues', { 'identificacion': customUpdateValueData('identificacion', identificacionNew.target.value) })"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonasCrearActualizarComponent',
  props: ['loadData', 'collectionTipoPersona', 'customUpdateValueData', 'collectionTipoDoc'],
  emits: ["updateValues"],
}
</script>